import { Component, OnInit, Input, OnChanges, Output, EventEmitter, SimpleChanges, ViewChild, AfterViewInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import SignaturePad from 'signature_pad';
import { EXAM_TYPES } from 'src/app/helpers/examTypes.helper';
import { TelehealthConsent } from 'src/app/models/telehealth-consent.model';
import { TelehealthConsentHistoryService } from 'src/app/services/repositories/shared-api/telehealth-content-history.service';


@Component({
    selector: 'signature-form',
    templateUrl: './signature-form.component.html',
    styleUrls: ['./signature-form.component.scss'],
    standalone: false
})
export class SignatureFormComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() examType: string = EXAM_TYPES.Vision;
  @Output() signage = new EventEmitter<string>();
  @ViewChild('sPad') signaturePadElement: any;

  public htmlText: SafeHtml | undefined;
  public signaturePad: any;
  public disableSave: boolean = true;

  constructor(private _telehealthContentHistoryService: TelehealthConsentHistoryService,
              private _sanitizer: DomSanitizer) {
  }

  resizeCanvas() {
    const canvas = this.signaturePadElement.nativeElement;
    const ratio =  Math.max(window.devicePixelRatio || 1, 1);

    // This part causes the canvas to be cleared
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext('2d').scale(ratio, ratio);
    this.signaturePad.clear();
  }

  ngOnInit() {
    this.getTelehealthConsentForm();
  }

  ngAfterViewInit(): void {
    this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement, {backgroundColor: 'rgb(255, 255, 255)'});
    this.resizeCanvas();
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  getTelehealthConsentForm() {
    this._telehealthContentHistoryService.getTelehealthContentForm(this.examType)
      .subscribe((data: TelehealthConsent) => {
        if (data) {
          this.htmlText = this._sanitizer.bypassSecurityTrustHtml(data.telehealthConsentContent);
        }
      }, (error) => {
        console.log(error);
      });
  }

  clearPad(agreeChk: any) {
    this.signaturePad.clear();
    agreeChk.checked = false;
    this.disableSave = true;
  }

  validatePad(event: any) {
    if (this.signaturePad.isEmpty() === false) {
      if (event.target.checked) {
        this.disableSave = false;
      } else {
        this.disableSave = true;
      }
    } else {
      this.disableSave = true;
      event.target.checked = false;
    }
  }

  saveSignature() {
    const sub64: string = this.signaturePad.toDataURL('image/jpeg');
    this.signage.emit(sub64);
  }

}

